import ModelContextProtocolSVG from '@/assets/svg/model-context-protocol.svg?react';
import { VibeCodingViaMCPModal } from '@/business-components/vibe-coding-via-mcp-modal/VibeCodingViaMCPModal';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { Button, Tooltip } from 'aui';
import clsx from 'clsx';
import React from 'react';

export type MCPButtonProps = {
  className?: string;
};

export function MCPButton(props: MCPButtonProps) {
  const { className } = props;

  const [vibeCodingViaMCPModal, setVibeCodingViaMCPModalVisible] = React.useState(false);
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const enableVibeCodingViaMCP = useDocsDataModelStore(
    (x) => x.docsBaseConfig.enableVibeCodingViaMCP,
  );

  if (!enableVibeCodingViaMCP) {
    return null;
  }
  return (
    <>
      {enableVibeCodingViaMCP && (
        <Tooltip title={clientI18n('api.action.mcp.modal.description')}>
          <Button
            type="default"
            size="small"
            className={clsx('animate-none transition-none', className)}
            icon={
              <span className="appicon">
                <ModelContextProtocolSVG />
              </span>
            }
            onClick={() => setVibeCodingViaMCPModalVisible(true)}
          >
            {clientI18n('docsSite.enableVibeCodingViaMCP')}
          </Button>
        </Tooltip>
      )}
      {vibeCodingViaMCPModal && (
        <VibeCodingViaMCPModal
          visible={vibeCodingViaMCPModal}
          onCancel={() => setVibeCodingViaMCPModalVisible(false)}
        />
      )}
    </>
  );
}
